import React, { useEffect } from 'react';

import { Main } from '../Sections/Main';
//import { LeftColumn } from './Sections/LeftColumn';
//import { RightColumn } from './Sections/RightColumn';
import { FullWidth } from '../Sections/FullWidth';
/*import { NavLink } from 'react-router-dom';*/

export const NotFound = (props) => {

    //useEffect(() => {
    //    props.resetState()
    //    props.initTool('0')
    //}, [])

    /*let instructions = ["Line1", "line2", "Line3"]*/

    return (
        <Main>
            <FullWidth title=''>
                <div className="d-flex flex-column align-items-start">

                    <h1>404 - Page Not Found</h1>
                    <p>The page you are looking for does not exist.</p>

                </div>
            </FullWidth>
        </Main>
    )
}
